module.exports = __webpack_public_path__ + "img/doorLogo40.0b9e51c9.png";